import React from "react";

const UserPanel = () => {
  return (
    <div>
      <h1>User panel</h1>
      {/* panel usera */}
    </div>
  );
};

export default UserPanel;